import {
  getV1CompaniesCompanyIdProjects,
  GetV1CompaniesCompanyIdProjectsData,
  Project_Read,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { Project } from '~hooks/useProjects/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Project_Read,
  Project,
  GetV1CompaniesCompanyIdProjectsData
> & { companyId: string };

export default function AutocompleteCompanyProjects<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteCompanyProjects"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdProjects,
      }}
      parseFn={(item: Project_Read) => {
        const parsed = Project.parse(item);

        return { _entity: parsed, label: parsed.name, value: parsed.id };
      }}
    />
  );
}
